import { Box, Button, Flex, Loading, Text, createColumnHelper } from 'ui'
import { useMemo } from 'react'
import { usePulseContext } from '../../context/PulseProvider'
import { useTopCompliments } from 'queries/pulse/useTopCompliments'
import { TopCompliments as TopComplimentsType } from 'api/pulse/topCompliments'
import { InfiniteTable } from '../InfiniteTable'
import { formatNumber } from 'lib/string'
import { startCase } from 'lodash'
import { useTopComplimentsDownloadCsv } from 'queries/pulse/useTopComplimentsDownloadCsv'

const columnHelper = createColumnHelper<TopComplimentsType[0]>()

const columns = [
  columnHelper.accessor('compliment', {
    header: 'Compliment',
    cell: (info) => <Text>{startCase(info.getValue())}</Text>,
  }),
  columnHelper.accessor('num_compliments', {
    header: 'Count',
    cell: (info) => <Text>{formatNumber(info.getValue() as number)}</Text>,
  }),
]

export function TopCompliments() {
  const {
    state: { filters },
  } = usePulseContext()

  const filtersWithPagination = useMemo(() => {
    return {
      ...filters,
      page: 0,
      pageSize: 50,
    }
  }, [filters])

  const { data, isLoading, isFetching, fetchNextPage, hasNextPage } =
    useTopCompliments(filtersWithPagination)

  const { mutateAsync: downloadCsv, isPending: isDownloadingCsv } =
    useTopComplimentsDownloadCsv(filters)

  const flatData = useMemo(() => {
    return data?.pages.flatMap((page) => page) ?? []
  }, [data])

  return (
    <Box flex={1}>
      <Flex
        flexDirection="row"
        justifyContent="space-between"
        alignItems="center"
        gap={3}
        mb={3}
      >
        <Box>
          <Text fontSize={3} fontWeight="500">
            Top Compliments
          </Text>
          <Text fontSize={2} color="lightText">
            Top compliments of Managers to Workers
          </Text>
        </Box>
        <Button
          variant="secondary"
          onClick={() => downloadCsv()}
          loading={isDownloadingCsv}
        >
          CSV
        </Button>
      </Flex>
      {isLoading ? (
        <Box p={3}>
          <Loading />
        </Box>
      ) : (
        <InfiniteTable
          data={flatData}
          columns={columns}
          isFetching={isFetching}
          fetchNextPage={fetchNextPage}
          hasNextPage={hasNextPage}
          height="400px"
        />
      )}
    </Box>
  )
}
